import React from 'react'

import * as Table from '../../../../components/Table'
import * as Components from '..'

import { ITableWrapperProps } from './types'

import { SHomeTitles } from './static'


const TableWrapper: React.FC<ITableWrapperProps> = ({
  items,
  sortHandler,
  reloadHandler,
}) => {

  return (
    <Table.Table
      type='archive' 
      titles={SHomeTitles}
      sortHandler={sortHandler}
    >
      {items.map(item => (
        <Components.Track
          data={item}
          key={item._id}
          reloadHandler={reloadHandler}
        />
      ))}
    </Table.Table>
  )
} 

export default TableWrapper 